<template>
  <div class="table-inner" style="width: 100%;">
    <el-table
      ref="table"
      v-loading="loading"
      class="table"
      size="small"
      :row-key="rowKey"
      :data="tableData"
      style="width:100%"
      :max-height="maxHeight"
      :tree-props="treeProps"
      @sort-change="sortChange"
      @select="select"
      @select-all="selectAll"
      @selection-change="selectionChange"
      @filter-change="filterChange"
    >
      <!-- 选择框 -->
      <slot name="selection" />
      <!-- 数据 -->
      <el-table-column
        v-for="item in tableColumn"
        :key="item.prop"
        :type="item.type"
        :width="item.width || ''"
        :align="item.align || 'center'"
        :label="item.label"
        :prop="item.prop"
        :column-key="item.prop"
        :filters="item.filters"
        :filter-multiple="false"
        :sortable="item.sortable || false"
        :show-overflow-tooltip="item.showOverflowTooltip || false"
      >
        <template slot-scope="scope">
          <span v-if="item.render" v-html="item.render(scope.row)" />
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <slot name="operate" />
      <!-- 操作 -->
      <!-- <el-table-column
        v-if="tableOption.label"
        :width="tableOption.width"
        :label="tableOption.label"
        align="center">
        <template slot-scope="scope">
          <el-button
            v-for="item in tableOption.options"
            :key="item.label"
            :type="item.type"
            :icon="item.icon"
            @click.native="handleButton(item.methods,scope.row)"
            size="mini">{{item.label}}</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <pagination v-show="page.total>0" :total="page.total" :page.sync="pageNum" :limit.sync="pageSizes" @pagination="getData" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'

export default {
  name:'MyTable',
  components: {
    Pagination
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },

    tableData: {
      type: Array,
      default: () => []
    },
    tableColumn: {
      type: Array,
      default: () => []
    },
    page: {
      type: Object,
      default: () => {
        return {
          total: 0,
          pageNo: 0,
          pageSize: 10
        }
      }
    },
    treeProps: {
      type: Object,
      default: () => {
        return 	{ hasChildren: 'hasChildren', children: 'children' }
      }
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    height: {
      type: String,
      default: '100%'
    },
    maxHeight: {
      type: String,
      default: '100%'
    }
    // tableOption: {
    //   type: Object,
    //   default: {}
    // }
  },
  data() {
    return { }
  },
  computed: {
    pageNum: {
      get() { return this.page.pageNo },
      set(val) { }
    },
    pageSizes: {
      get() { return this.page.pageSize },
      set(val) { }
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 分页点击获取数据
    getData(data) {
      this.$emit('pageChange', data)
    },
    // 后端排序 data: {column, prop, order: "descending" "ascending"} 降序和升序
    sortChange(data) {
      this.$emit('sortChange', data)
    },
    select(selection, row) {
      this.$emit('select', selection, row)
    },
    selectAll(selection) {
      this.$emit('selectAll', selection)
    },
    selectionChange(data) {
      this.$emit('selectionChange', data, data.map(item => item[this.rowKey]))
    },
    filterChange(filters) {
      this.pageNum = 1
      this.$emit('filterChange', filters)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-inner{
  display: flex;
  flex-direction: column;
  .el-table{
    flex: 1;
    overflow: auto;
    ::v-deep th{
      background-color: #F7F7F7;
      // background-color: #d9ecff;
      color:rgba($color: #000000, $alpha: 0.7);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyTable/index.vue